export const buildFeeText = (paymentMethod) => {
  if (!paymentMethod) {
    return 'No fee';
  }

  const { fee, fee_min, fee_max } = paymentMethod;
  const fee_percentage = Number(paymentMethod.fee_percentage);

  if (fee === '$0') {
    return 'No fee';
  }

  if (fee_percentage === 0) {
    return `${fee || 'No'} fee`;
  }

  if (fee_min && fee_max) {
    return `${fee_percentage}% fee capped at ${fee_max}, minimum ${fee_min}`;
  }

  if (fee_max) {
    return `${fee_percentage}% fee capped at ${fee_max}`;
  }

  if (fee_min) {
    return `${fee_percentage}% fee, minimum ${fee_min}`;
  }

  return `${fee_percentage}% fee`;
};
